import {
  FC,
  ReactNode,
  CSSProperties,
  useState,
  useEffect,
  useCallback,
  useRef,
} from 'react';
import { ProSelect } from '../antd';
import useDebounce from '../Hooks/useDebounce';
import { dataToOptionData } from '../utils/methods';
import { flatArray } from '../utils/dataUtils';
import { SUCCESS_STATUS_CODE } from '../constants/constant';
import { SelectGroupProps, IGroupOptions } from './interface';

const selectStyle: CSSProperties = { width: '100%' };
/** 下拉分组 */
const SelectGroup: FC<SelectGroupProps> = props => {
  const {
    groupOptions: groupOptionsProps,
    style,
    labelKey = 'label',
    valueKey = 'value',
    childrenKey = 'children',
    groupLabelKey,
    groupValueKey,
    dataKey = false,
    value,
    searchKey,
    params,
    showSearch,
    mode,
    fetchApi,
    onChange,
    ...restProps
  } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [searchValue, setSearchValue] = useState<string>();
  const [groupOptions, setGroupOptions] = useState<IGroupOptions[]>([]);
  const [selectValue, setSelectValue] = useState<any>();
  const debouncedValue = useDebounce(searchValue);
  const flatOptions = useRef<any[]>([]);
  useEffect(() => {
    setGroupOptions(groupOptionsProps || []);
  }, [groupOptionsProps]);
  useEffect(() => {
    if (showSearch && fetchApi && debouncedValue) {
      onFetch().then(data => {
        setGroupOptions(data);
      });
    }
  }, [debouncedValue]);
  useEffect(() => {
    setSelectValue(value);
    if (!groupOptions.length && fetchApi && value) {
      onFetch().then(data => {
        setGroupOptions(data);
      });
    }
  }, [value]);
  useEffect(() => {
    if (value && fetchApi) {
      onFetch().then(data => {
        setGroupOptions(data);
      });
    }
  }, []);
  // 获取数据
  const onFetch = async () => {
    if (!fetchApi) return [];
    setLoading(true);
    const apiParams: any = { ...params };
    if (debouncedValue) apiParams[searchKey || labelKey] = debouncedValue;
    const res = await fetchApi(apiParams);
    setLoading(false);
    if (res.code === SUCCESS_STATUS_CODE) {
      const data = res.data;
      const resule = data ? (dataKey ? data[dataKey] : data) : [];
      if (Array.isArray(resule)) {
        flatOptions.current = flatArray(resule, childrenKey);
        return dataToOptionData(
          resule,
          labelKey,
          valueKey,
          childrenKey,
          groupLabelKey || labelKey,
          groupValueKey || valueKey,
        );
      }
    }
    flatOptions.current = [];
    return [];
  };
  const handleFilterOption = (inputValue: string | number, option: any) => {
    return (option.label || option.children)?.includes(inputValue);
  };
  // 文本框值变化时回调
  const handleSearch = (value: string) => {
    // setSearchValue(value);
  };
  // 展开下拉菜单的回调
  const handleDropdownVisibleChange = async (open: boolean) => {
    if (!open || loading || groupOptions.length) return;
    const data = await onFetch();
    setGroupOptions(data);
  };
  // 选中的值改变
  const handleChange = (value: any, option: any) => {
    setSelectValue(value);
    if (fetchApi) {
      const filterOption = flatOptions.current.filter(item => {
        if (Array.isArray(value)) return value.includes(item[valueKey]);
        return item[valueKey] === value;
      });
      onChange?.(value, Array.isArray(value) ? filterOption : filterOption[0]);
      return;
    }
    onChange?.(value, option);
  };
  // 生成分组节点
  const renderOptGroup = useCallback(
    (options: IGroupOptions[]): ReactNode => {
      return options.map(option => {
        const { label, value, children } = option;
        if (Array.isArray(children) && children.length) {
          return (
            <ProSelect.OptGroup label={label} key={value}>
              {renderOptGroup(children)}
            </ProSelect.OptGroup>
          );
        } else {
          return (
            <ProSelect.Option value={value} key={value}>
              {label || value}
            </ProSelect.Option>
          );
        }
      });
    },
    [groupOptions],
  );
  return (
    <ProSelect
      style={style || selectStyle}
      mode={mode}
      showSearch={showSearch}
      loading={loading}
      value={selectValue}
      // onSearch={handleSearch}
      filterOption={handleFilterOption}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      onChange={handleChange}
      {...restProps}
    >
      {renderOptGroup(groupOptions)}
    </ProSelect>
  );
};

SelectGroup.defaultProps = {
  showSearch: true,
  labelKey: 'label',
  valueKey: 'value',
  childrenKey: 'children',
};

export default SelectGroup;
